import * as CONFIG from 'config';
import defaultCss from './default.module.css';
import css from 'styles/Navigations.module.css';
import classnames from 'classnames/bind';
import { useContext, useEffect, useRef, useState } from 'react';
import { CatalogContext } from 'Catalog/Catalog.context';
import CatalogLink from 'Catalog/CatalogLink';
import { PrevButton, NextButton } from 'Catalog/PagingButtons';
import AutoplayButton from 'Catalog/AutoplayButton';
import { motion, AnimatePresence } from 'framer-motion';
import { easing } from 'settings';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

const cx = classnames.bind(css);

export default function Navigations() {
  return (
    <div className={defaultCss.container}>
      <Header />
      <Controller />
    </div>
  );
}

function Header() {
  const { activePageInfo, lang, pageNum, autoplayRunning } = useContext(CatalogContext);
  const mobileMenuButtonRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const [openMobileMenu, setOpenMobileMenu] = useState(false);

  useEffect(() => {
    const resetMobileMenu = e => {
      if (!mobileMenuButtonRef?.current?.contains(e.target) && !mobileMenuRef?.current?.contains(e.target)) {
        setOpenMobileMenu(false);
      }
    };
    window.addEventListener('click', resetMobileMenu);

    return () => {
      window.removeEventListener('click', resetMobileMenu);
    };
  }, []);
  useEffect(() => setOpenMobileMenu(false), [pageNum]);

  if (!activePageInfo || !lang) {
    return null;
  }

  if (lang === 'ko') {
    return (
      <header
        className={`${css.header} ${activePageInfo.headerState === 'show' ? css.header__show : css.header__hide} ${
          css[`theme--${activePageInfo.headerTheme}`]
        }`}
      >
        <h1 className={cx('logo')}>
          <CatalogLink to='1'>
            <img
              src={`${CONFIG.IMG_URL}/common/logo.svg`}
              alt='Q-Platform'
            />
          </CatalogLink>
        </h1>
        <nav className={cx('nav-wrap')}>
          <ul className={cx('gnb')}>
            <li className={cx('gnb-item', { active: activePageInfo.depth1 === 'intro' })}>
              <CatalogLink to='2'>
                <span>
                  <b>Q-Platform</b>
                </span>
                {activePageInfo.depth1 === 'intro' && (
                  <motion.div
                    className={cx('tablet')}
                    layoutId='tablet'
                    transition={{ ease: 'easeOut' }}
                  ></motion.div>
                )}
              </CatalogLink>
            </li>
            <li className={cx('gnb-item', { active: activePageInfo.depth1 === 'qp-service' })}>
              <CatalogLink to='3'>
                <span>Q-Platform Service</span>
                {activePageInfo.depth1 === 'qp-service' && (
                  <motion.div
                    className={cx('tablet')}
                    layoutId='tablet'
                    transition={{ ease: 'easeOut' }}
                  ></motion.div>
                )}
              </CatalogLink>
              <AnimatePresence>
                {activePageInfo.depth1 === 'qp-service' && (
                  <motion.ul
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    className={cx('submenu')}
                  >
                    <li
                      className={cx('submenu-item', 'ff-secondary', {
                        active: activePageInfo.depth2 === 'competitiveness',
                      })}
                    >
                      <CatalogLink to='3/1'>핵심 경쟁력</CatalogLink>
                    </li>
                    <li
                      className={cx('submenu-item', 'ff-secondary', {
                        active: activePageInfo.depth2 === 'biz-capability',
                      })}
                    >
                      <CatalogLink to='4'>사업화 역량</CatalogLink>
                    </li>
                    <li className={cx('submenu-item', { active: activePageInfo.depth2 === 'qp-highlight' })}>
                      <CatalogLink to='5/1'>Q-P Highlight</CatalogLink>
                    </li>
                    <li
                      className={cx('submenu-item', 'ff-secondary', {
                        active: activePageInfo.depth2 === 'service-models',
                      })}
                    >
                      <CatalogLink to='6/1'>제공 서비스 모델</CatalogLink>
                    </li>
                  </motion.ul>
                )}
              </AnimatePresence>
            </li>
            <li className={cx('gnb-item', { active: activePageInfo.depth1 === 'company' })}>
              <CatalogLink to='7'>
                <span>Company</span>
                {activePageInfo.depth1 === 'company' && (
                  <motion.div
                    className={cx('tablet')}
                    layoutId='tablet'
                    transition={{ ease: 'easeOut' }}
                  ></motion.div>
                )}
              </CatalogLink>
              <AnimatePresence>
                {activePageInfo.depth1 === 'company' && (
                  <motion.ul
                    initial={{ opacity: 0, y: -20, x: '-50%' }}
                    animate={{ opacity: 1, y: 0, x: '-50%' }}
                    exit={{ opacity: 0, y: -20, x: '-50%' }}
                    className={cx('submenu')}
                  >
                    <li className={cx('submenu-item', { active: activePageInfo.depth2 === 'overview' })}>
                      <CatalogLink to='7'>Overview</CatalogLink>
                    </li>
                    <li className={cx('submenu-item', { active: activePageInfo.depth2 === 'vision' })}>
                      <CatalogLink to='8'>Vision</CatalogLink>
                    </li>
                    <li className={cx('submenu-item', { active: activePageInfo.depth2 === 'manpower' })}>
                      <CatalogLink to='9'>Manpower</CatalogLink>
                    </li>
                    <li className={cx('submenu-item', { active: activePageInfo.depth2 === 'bi' })}>
                      <CatalogLink to='10'>BI Story</CatalogLink>
                    </li>
                  </motion.ul>
                )}
              </AnimatePresence>
            </li>
          </ul>
          <div className={cx('etc')}>
            <AutoplayButton className={cx('btn', 'btn-autoplay')}>
              <img
                src={`${CONFIG.IMG_URL}/common/ico-play${autoplayRunning ? '-white' : ''}.svg`}
                alt='Autoplay'
              />
            </AutoplayButton>
          </div>
        </nav>
        <button
          type='button'
          ref={mobileMenuButtonRef}
          className={cx('m-btn', 'btn-menu')}
          onClick={() => setOpenMobileMenu(!openMobileMenu)}
        >
          <img
            src={`${CONFIG.IMG_URL}/common/ico-hamburger.svg`}
            alt='Menu'
          />
        </button>
        {openMobileMenu && (
          <motion.nav
            ref={mobileMenuRef}
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ ease: easing.pop, duration: 0.5 }}
            className={cx('m-menu')}
          >
            <ul className={cx('depth1')}>
              <li className={cx('depth1-item')}>
                <CatalogLink to='1'>Main</CatalogLink>
              </li>
              <li className={cx('depth1-item')}>
                <CatalogLink to='2'>Q-Platform</CatalogLink>
              </li>
              <li className={cx('depth1-item')}>
                <CatalogLink to='3/1'>Q-Platform Service</CatalogLink>
                <ul className={cx('depth2')}>
                  <li className={cx('depth2-item')}>
                    <CatalogLink to='3/1'>핵심 경쟁력</CatalogLink>
                  </li>
                  <li className={cx('depth2-item')}>
                    <CatalogLink to='4/1'>사업화 역량</CatalogLink>
                  </li>
                  <li className={cx('depth2-item')}>
                    <CatalogLink to='5/1'>Q-P Highlight</CatalogLink>
                  </li>
                  <li className={cx('depth2-item')}>
                    <CatalogLink to='6/1'>제공 서비스 모델</CatalogLink>
                  </li>
                </ul>
              </li>
              <li className={cx('depth1-item')}>
                <CatalogLink to='7'>Company</CatalogLink>
                <ul className={cx('depth2')}>
                  <li className={cx('depth2-item')}>
                    <CatalogLink to='7'>Overview</CatalogLink>
                  </li>
                  <li className={cx('depth2-item')}>
                    <CatalogLink to='8'>Vision</CatalogLink>
                  </li>
                  <li className={cx('depth2-item')}>
                    <CatalogLink to='9'>Manpower</CatalogLink>
                  </li>
                  <li className={cx('depth2-item')}>
                    <CatalogLink to='10'>BI Story</CatalogLink>
                  </li>
                </ul>
              </li>
              <li className={cx('depth1-item')}>
                <CatalogLink to='10'>Last</CatalogLink>
              </li>
            </ul>
          </motion.nav>
        )}
      </header>
    );
  } else {
    return (
      <header
        className={`${css.header} ${activePageInfo.headerState === 'show' ? css.header__show : css.header__hide} ${
          css[`theme--${activePageInfo.headerTheme}`]
        }`}
      ></header>
    );
  }
}

function Controller() {
  const { pageNum, pageTotal } = useContext(CatalogContext);
  return (
    <nav className={cx('controller')}>
      <PrevButton className={cx('btn', 'prev', { disabled: pageNum === 1 })}>
        <IoIosArrowBack className={cx('icon')} />
      </PrevButton>
      <NextButton className={cx('btn', 'next', { disabled: pageNum === pageTotal })}>
        <IoIosArrowForward className={cx('icon')} />
      </NextButton>
    </nav>
  );
}
